module.exports = __webpack_public_path__ + "static/img/pet.751c628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/pet.png
// module id = X9vh
// module chunks = 58